import React from 'react';
import moment from 'moment';
import { Chip } from '@material-ui/core';
import ListarDatos from '../../../../general/ListarDatos';

function DetalleObservacionesTab({ observaciones }) {
    return (
        <ListarDatos
            datos={observaciones}
            id='tbl_observaciones_bienestar'
            fila_principal={({ usuario_registro }) => usuario_registro
                ? `${usuario_registro.primer_nombre} ${usuario_registro.primer_apellido} ${usuario_registro.segundo_apellido}`
                : 'Usuario Desconocido'}
            filas={[
                { id: 'fecha_registro', nombre: 'Fecha:', mostrar: ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a') },
                {
                    id: 'texto',
                    mostrar: ({ texto, es_interna }) => (
                        <>
                            <span style={{ whiteSpace: 'pre-line' }}><strong>{texto}</strong></span>
                            {es_interna && <Chip component="span" size="small" label="Interna" color="primary" style={{ marginLeft: '8px' }} />}
                        </>
                    ) || 'Sin detalles',
                },
            ]}
        />
    );
}

export default React.memo(DetalleObservacionesTab);
